
import { TranslationsObject } from './types';
import { kaTranslations } from './languages/ka';
import { enTranslations } from './languages/en';
import { ruTranslations } from './languages/ru';
import { trTranslations } from './languages/tr';

// Centralizing all translations in this file
export const translations: Record<string, TranslationsObject> = {
  ka: kaTranslations,
  en: enTranslations,
  ru: ruTranslations,
  tr: trTranslations,
};
